import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { HashRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { RecoilRoot } from 'recoil';
import { ErrorBoundary } from 'react-error-boundary';

import theme from './theme';
import Wrapper from './Wrapper';
import ErrorBounderyFallback from './component/ErrorBounderyFallback';

const queryClient = new QueryClient();

const App = () => {
  return (
    <Router>
      <RecoilRoot>
        <ThemeProvider theme={theme}>
          <QueryClientProvider client={queryClient}>
            <ErrorBoundary
              FallbackComponent={ErrorBounderyFallback}
              onReset={() => {}}
            >
              <Wrapper />
            </ErrorBoundary>
          </QueryClientProvider>
        </ThemeProvider>
      </RecoilRoot>
    </Router>
  );
};

export default App;
